import formatCurrency from '@/lib/utils/formatCurrency'
import { PaidStatus, type TradeBuyer, type TradeDuration } from '@/typings/trade'
import dayjs from 'dayjs'

export const DURATION_OPTIONS: { value: TradeDuration; label: string }[] = [
  { value: 'all', label: '全部时间' },
  { value: 'last7days', label: '最近7天' },
  { value: 'last14days', label: '最近14天' },
  { value: 'last30days', label: '最近30天' },
  { value: 'last90days', label: '最近90天' },
]

export const PAID_STATUS_OPTIONS: { value: PaidStatus | 'all'; label: string }[] = [
  { value: 'all', label: '全部订单' },
  { value: PaidStatus.Paid, label: '已支付' },
  { value: PaidStatus.Unpaid, label: '未支付' },
  { value: PaidStatus.Refunded, label: '已退款' },
  { value: PaidStatus.Refunding, label: '退款中' },
  { value: PaidStatus.PartialRefunded, label: '部分退款' },
]

type StatusColor = 'systemGreen' | 'secondaryLabel' | 'systemOrange' | 'systemRed'
type StatusIcon = 'checkmark.circle' | 'info.circle' | 'clock' | 'exclamationmark.circle'

export const PAID_STATUS_META: Record<
  PaidStatus,
  { label: string; color: StatusColor; sign: string; icon: StatusIcon }
> = {
  [PaidStatus.Paid]: { label: '已支付', color: 'systemGreen', sign: '+', icon: 'checkmark.circle' },
  [PaidStatus.Unpaid]: { label: '未支付', color: 'secondaryLabel', sign: '', icon: 'info.circle' },
  [PaidStatus.Refunding]: { label: '退款中', color: 'systemOrange', sign: '-', icon: 'clock' },
  [PaidStatus.Refunded]: { label: '已退款', color: 'systemRed', sign: '-', icon: 'exclamationmark.circle' },
  [PaidStatus.PartialRefunded]: {
    label: '部分退款',
    color: 'systemOrange',
    sign: '-',
    icon: 'clock',
  },
}

export const REFUND_STATUS_LABEL = { processing: '退款中', success: '退款成功', error: '退款失败' } as const

export function formatAmount(value: number | string | null | undefined) {
  return formatCurrency({ value: Number(value ?? 0) })
}

export function formatPlainAmount(value: number | string | null | undefined) {
  return Number(value ?? 0).toFixed(2)
}

export function formatDateTime(value: string | null | undefined) {
  return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
}

export function formatConversionRate(transactionsCount = 0, ordersCount = 0) {
  return `${((transactionsCount / (ordersCount || 1)) * 100).toFixed(1)}%`
}

export function formatBuyerAddress(address: TradeBuyer['address']) {
  if (!address) return ''
  if (typeof address === 'string') return address
  return [address.province, address.city, address.district, address.street].filter(Boolean).join('')
}

export function orderTitle(items: { name: string }[]) {
  const [first] = items
  if (!first) return '订单'
  return items.length > 1 ? `${first.name} 等` : first.name
}
